module.exports = __webpack_public_path__ + "img/S.1ad25190.svg";